export const categories = {
  1: 'category.ebooks.name',
  2: 'category.software.name',
  3: 'category.apps.name',
  4: 'category.videos.name',
  5: 'category.audios.name',
  6: 'category.templates.name',
  7: 'category.images.name',
  8: 'category.online_services.name',
  9: 'category.serial_codes.name',
  10: 'category.etickets.name',
  11: 'category.online_service.name',
  12: 'category.online_event.name'
}

export const HOLDING_AUTHORITY = 'holding'
